export enum SWRKeysEnum {
  GET_CAMERA_SETTINGS = 'get-camera-settings',
  GET_CAMERA_LANGUAGES = 'get-camera-languages',
  CONTINUE_CAPTURE_PROCESS = 'continue-capture-process',
  GET_BACKEND_STATE = 'get-backend-state',
  LOAD_SESSION = 'load-session',
}
